var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-dialog',{attrs:{"persistent":""},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[(_vm.recipient)?_c('recipient-form',{attrs:{"saving":_vm.loading},on:{"submit":_vm.addRecipient},model:{value:(_vm.recipient),callback:function ($$v) {_vm.recipient=$$v},expression:"recipient"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }